/** @format */

import React, { useState, useEffect } from "react";
import { assetsPath } from "../utils/assetsPath";

const LabelTextArea = ({
  id,
  label,
  placeholder,
  register,
  errors,
  watch,
  disabled,
  className,
  emailclass,
  tooltipText,
  value = "",
  classTick,
  maxLength,
  trigger,
  onChange = () => {},
  onInput = () => {},
  liveValidate = true,
  ...props
}) => {
  const [isInputClicked, setIsInputClicked] = useState(true);

  useEffect(() => {
    if (watch && liveValidate) {
      const trig = async () => await trigger(id);
      trig();
    }
  }, [watch]);

  return (
    <div className={`licField width-100 ${className}`}>
      {label && (
        <label className="labelName" htmlFor={id}>
          {label}
        </label>
      )}
      <div className={`licField margin-bottom-15`}>
        <div
          data-clicked={isInputClicked ? "true" : "false"}
          className={`newInputField ${classTick}`}
        >
          <textarea
            {...props}
            autoComplete="off"
            disabled={disabled}
            onChange={onChange}
            onBlurCapture={() => setIsInputClicked(true)}
            onBlur={() => setIsInputClicked(true)}
            onFocus={() => setIsInputClicked(false)}
            data-clicked={isInputClicked ? "true" : "false"}
            placeholder={placeholder}
            id={id}
            className={`${errors ? "error" : ""}`}
            {...register}
            maxLength={maxLength}
            onInput={onInput}
          />
          {tooltipText && (
            <span className={`tooltip ${emailclass}`}>{tooltipText}</span>
          )}
        </div>

        {errors && <span className="errorField">{errors.message}</span>}
      </div>
    </div>
  );
};

export default LabelTextArea;
